export interface SidebarElement {
  label: string;
  icon: string;
  to?: string;
  adminOnly?: boolean;
  click?: () => void;
  comingSoon?: boolean;
}

export const useSidebar = () => {
  const route = useRoute();

  const isAdminSection = computed(() => route.path.startsWith("/admin"));

  const regularSidebarElements = ref<SidebarElement[]>([
    {
      label: "Accueil",
      icon: "ph-house",
      to: "/dashboard",
    },
    {
      label: "Scanner",
      icon: "ph-qr-code",
      to: "/scanner",
    },
    {
      label: "Clients",
      icon: "ph-users",
      to: "/customers",
    },
    {
      label: "Abonnements",
      icon: "ph-credit-card",
      to: "/subscription-plans",
      adminOnly: true,
    },
    {
      label: "Cartes cadeaux (Bientôt)",
      icon: "ph-gift",
      click: () => {
        useToast().add({
          title: "Fonctionnalité à venir",
          description: "Cette fonctionnalité sera disponible prochainement.",
          color: "gray",
        });
      },
    },
    {
      label: "Paramètres",
      icon: "ph-gear",
      to: "/settings",
      adminOnly: true,
    },
  ]);

  const adminSidebarElements = ref<SidebarElement[]>([
    {
      label: "Marchands",
      icon: "ph-storefront",
      to: "/admin",
    },
    {
      label: "Paramètres",
      icon: "ph-gear",
      to: "/admin/settings",
    },
    {
      label: "Quitter Admin",
      icon: "ph-arrow-left",
      to: "/",
    },
  ]);

  const sidebarElements = computed(() =>
    isAdminSection.value
      ? adminSidebarElements.value
      : regularSidebarElements.value
  );

  return {
    sidebarElements,
    isAdminSection,
  };
};
